import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useFunnelBoot } from '../booking/lib/boot';
import { PaymentPage } from '../booking/payment-page';

/** Step 3 of the funnel (MASTER_PLAN M5.5, M5.7). */
export const Route = createFileRoute('/payment')({
  component: PaymentRoute,
});

function PaymentRoute() {
  const navigate = useNavigate();
  useFunnelBoot('payment');

  return (
    <PaymentPage
      onContinue={() => {
        void navigate({ to: '/paperwork' });
      }}
      onBlocked={() => {
        void navigate({ to: '/insurance' });
      }}
    />
  );
}
